import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { Referral } from '../../../../types/schema/referral.types';

interface GetAllReferralsByPageHook {
  data: Referral[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllReferralsByPage: Referral[];
    }>
  >;
}

interface UseGetAllReferralsByPageMutationData {
  getAllReferralsByPage: Referral[];
}

interface UseGetAllReferralsByPageInputType {
  input: PaginationInput;
}

export function useGetAllReferralsByPage(
  query: DocumentNode,
  input: PaginationInput
): GetAllReferralsByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    UseGetAllReferralsByPageMutationData,
    UseGetAllReferralsByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllReferralsByPage,
    loading,
    error,
    refetch,
  };
}
